import uniAxios from "../environment/uni/axios";
import vueAxios from "../environment/vue/axios";

import { isUni } from "./index";

const http = isUni() ? uniAxios : vueAxios;

export default http;
